import "core-js/stable";
import "regenerator-runtime/runtime";

import $ from 'jquery';

window.$ = $;
window.jQuery = $;

import {LoadConfig} from 'src/loadConfig.js'

(async () => {
    await LoadConfig()
    let l = await import('./login.js')
    await l.default.SignInInit()

    import('./main.js');
})();
